import { useEffect, useRef, useState } from 'react';
import type { ErrorNotice } from '../lib/errorEvents';

export default function ErrorToast() {
  const [message, setMessage] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const onError = (event: Event) => {
      const detail = (event as CustomEvent<ErrorNotice>).detail;
      if (!detail?.message) return;
      setMessage(detail.message);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setMessage(null), 6000);
    };
    window.addEventListener('ss:error', onError);
    return () => {
      window.removeEventListener('ss:error', onError);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  if (!message) return null;
  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 10000,
        maxWidth: 420,
        padding: '12px 14px',
        border: '1px solid var(--danger)',
        borderRadius: 8,
        background: 'var(--surface)',
        color: 'var(--text)',
        boxShadow: '0 12px 36px rgba(0,0,0,.35)',
        fontSize: 13,
      }}
      onClick={() => setMessage(null)}
    >
      {message}
    </div>
  );
}
